export const environment = {
    production: false,
    stage: false,
    dev: true,
    logging: false,
    version: 'dev',
    firebaseConfig: {
        apiKey: 'AIzaSyCouCTQiSEHMhT1hIDwqCkaP3hMnjLSgBI',
        authDomain: 'soc-firebase-dev.firebaseapp.com',
        databaseURL: 'https://soc-firebase-dev.firebaseio.com',
        projectId: 'soc-firebase-dev',
        storageBucket: 'soc-firebase-dev.appspot.com',
        messagingSenderId: '151949849974'
    },
    appBaseUrl: 'https://soc-firebase-dev.firebaseapp.com',
    apiServiceUrl: 'https://api-dot-soc-firebase-dev.uc.r.appspot.com',
    searchServiceBaseUrl: 'https://dev-dot-soc-search-service.uc.r.appspot.com',
    analyticsServiceBaseUrl: 'https://dev-dot-soc-analytics-service.uc.r.appspot.com',
    userServiceBaseUrl: 'https://user-dot-soc-firebase-dev.uc.r.appspot.com',
    functionsBaseUrl: 'https://us-central1-soc-firebase-dev.cloudfunctions.net',
    storageBaseUrl: 'https://firebasestorage.googleapis.com/v0/b/soc-firebase-dev.appspot.com',
    projectPortalServiceBaseUrl: 'https://projects-portal-dot-soc-firebase-dev.uc.r.appspot.com',
    chatServiceBaseUrl: 'https://chat-dot-soc-firebase-dev.appspot.com',
    googleRecaptchaSecretKey: '6LfnI-MUAAAAANCvywsJ90mnIdT_s9zlPOJiOaLz',
    elBaseUrl: 'https://soc-firebase-dev.firebaseapp.com',
};
import 'zone.js/plugins/zone-error';
